import { MapLatLng } from './map.latlng';
import { MapPlace } from './map.place';

export class MapSearch {
    public position: MapLatLng;
    public place: MapPlace;

    constructor(position: MapLatLng, place: MapPlace) {
        this.position = position;
        this.place = place;
    }
}
